export const AUTH_RETRY_KEY = 'auth-retry-dt';
export const JWT_RETRY_KEY = 'jwt-retry-ts';
export const RETRY_WINDOW_HOURS = 24;

export const SYSTEM_ROLES = ['UI', 'Developer', 'Integration'];

export const QueryNames = {
    ChapterWiseMetricsSummary: 'Chapter Wise Metrics Summary',
    DashboardMetricsSummaryForStaff: 'Dashboard Metrics Summary For Staff',
    DashboardMetricsSummary: 'Dashboard Metrics Summary',
    DistinctColumnValues: 'Distinct Column Values',
    PersonChapterLink: 'Person Chapter Link'
}

export const EntityNames = {
    ChapterDuesByMembers: 'Chapter Dues By Members',
    ChapterDuesSummaries: 'Chapter Dues Summaries',
    ChapterOfficers: 'Chapter Officers',
    CommitteeWiseMetrics: 'Committee Wise Metrics',
    Committees: 'Committees',
    DashboardMetrics: 'Dashboard Metrics',
    DuesManagementSummaries: 'Dues Management Summaries',
    DuesRecordsMetrics: 'Dues Records Metrics',
    MembershipRosterMetrics: 'Membership Roster Metrics',
    MembershipRosters: 'Membership Rosters',
    Permissions: 'Permissions',
    Resources: 'Resources',
    RoleResourcePermissions: 'Role Resource Permissions',
    // Impersonation entities
    ImpersonationSessions: 'Impersonation Sessions',
    ImpersonationAuditLogs: 'Impersonation Audit Logs',
    ImpersonationPermissionRules: 'Impersonation Permission Rules',
    // Access logging entity
    PortalAccessLogs: 'Portal Access Logs',
    // Extended user entity
    ExtendedUsers: 'Extended Users',
    // Core entities
    Users: 'Users',
    Roles: 'Roles',
    UserRoles: 'User Roles'
}